module.exports = __webpack_public_path__ + "static/img/pc-04.00a388f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w10/pc-04.jpg
// module id = nGzn
// module chunks = 1